import { Component, ElementRef, inject, viewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import SharedModule from 'app/shared/shared.module';
import { Registration } from './register.model';
import { RegisterService } from './register.service';
import FooterComponent from 'app/layouts/footer/footer.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import PrivacyPolicyComponent from './privacyPolicy/privacyPolicy.component';
import { AlertService } from 'app/core/util/alert.service';

@Component({
  standalone: true,
  selector: 'jhi-register',
  imports: [
    SharedModule,
    RouterModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    FooterComponent,
    MatCheckboxModule,
    MatCardModule,
    MatExpansionModule,
  ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss',
})
export default class RegisterComponent {
  users: string[] = ['Supplier', 'Buyer'];
  isBuyer: any;
  panelOpenState = false;
  countries: any = [
    { id: 1, code: 'IN', name: 'India' },
    { id: 2, code: 'US', name: 'Unites States' },
    { id: 3, code: 'RS', name: 'Russia' },
  ];
  registerForm = new FormGroup({
    email: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')],
    }),
    password: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.minLength(8), Validators.maxLength(16)],
    }),
    companyName: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.maxLength(50)],
    }),
    contactPerson: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.maxLength(50)],
    }),
    country: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    mobileNumber: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.pattern('^[0-9]{10}$')],
    }),
    userType: new FormControl('Supplier', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    privacyPolicy:new FormControl(false, {
      nonNullable: true,
      validators: [Validators.requiredTrue],
    }),
  });
  login = viewChild.required<ElementRef>('login');
  passwordVisible: boolean = false;
  private registerService = inject(RegisterService);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private alertService: AlertService,
  ) {}

  onLoginClick(): void {
    this.router.navigate(['/buyerLogin'], { relativeTo: this.route });
  }

  openPrivacy() {
    this.dialog.open(PrivacyPolicyComponent, {
      maxHeight: '77vh',
      maxWidth: '90vh',
      width: '90%',
      disableClose: true,
    });
  }

  signup(): void {
    if(this.registerForm.invalid){
      return
    }
    const payload = {
      companyName: this.registerForm.controls.companyName.value,
      contactPerson: this.registerForm.controls.contactPerson.value,
      country: this.registerForm.controls.country.value,
      user: {
        login: this.registerForm.controls.email.value,
        password: this.registerForm.controls.password.value,
        email: this.registerForm.controls.email.value,
        mobileNumber: this.registerForm.controls.mobileNumber.value,
      },
    };
    const userType = this.registerForm.get('userType')?.value;
    const registerDetails = new Registration(payload.companyName, payload.contactPerson, payload.country, payload.user);
    if (userType === 'Buyer') {
      this.registerService.saveBuyer(registerDetails).subscribe({
        next: () => {
          this.alertService.addAlert({ type: 'success', message: `Register Sucessfully!` });
          this.redirectToRfqScreen();
        },
        error: response => console.error(response),
      });
    } else {
      this.registerService.saveSupplier(registerDetails).subscribe({
        next: () => {
          this.alertService.addAlert({ type: 'success', message: `Register Sucessfully!` });
          this.redirectToRfqScreen();
        },
        error: response => console.error(response),
      });
    }
  }

  onClickRevealPassword(event: any): void {
    event.preventDefault();

    if (event?.pointerType) {
      this.passwordVisible = !this.passwordVisible;
    }
  }

  redirectToRfqScreen(): void {
    setTimeout(() => {
      this.router.navigate(['/buyerLogin'], { relativeTo: this.route });
    }, 2000);
  }
}
